
import React from "react";
import { useState, useEffect } from "react";
import Title from "../assets/texts/h1-desktop";
import Text from "../assets/texts/body-desktop";
import Button from "../assets/buttons/btnPrimary";
import TitleCard from "../assets/texts/titleCard-mobile";
import ImgAboutUsOne from "../assets/images/320px/320_about_1.png";
import ImgAboutUsTwo from "../assets/images/320px/320_about_2.png";
import ImgAboutUsThree from "../assets/images/320px/320_about_3.png";
/*  */
import ImgTeamDavid320 from "../assets/images/320px/320_david_ding.png";
import ImgTeamUriel320 from "../assets/images/320px/320_uriel_natero.png";
import ImgTeamHumberto320 from "../assets/images/320px/320_humberto_bertazza.png";
import ImgTeamAlejandroO320 from "../assets/images/320px/320_alejandro_ottero.png";
import ImgTeamMaria320 from "../assets/images/320px/320_maria_mao.png";
import ImgTeamCarlos320 from "../assets/images/320px/320_carlos_silvani.png";
import ImgTeamRomina320 from "../assets/images/320px/320_romina_fiorenza.png";
import ImgTeamAlejandroC320 from "../assets/images/320px/320_alejandro_cabaccheff.png";
import ImgTeamLeonardo320 from "../assets/images/320px/320_leonardo_bonomo.png";
import ImgTeamMrSong320 from "../assets/images/320px/320_mr_song.png";
import ImgTeamMrWu320 from "../assets/images/320px/320_mr_wu_mr_wang.png";
/*  */
import ImgTeamDavid768 from "../assets/images/768px/768_david_ding.png";
import ImgTeamUriel768 from "../assets/images/768px/768_uriel_natero.png";
import ImgTeamHumberto768 from "../assets/images/768px/768_humberto_bertazza.png";
import ImgTeamAlejandroO768 from "../assets/images/768px/768_alejandro_ottero.png";
import ImgTeamMaria768 from "../assets/images/768px/768_maria_mao.png";
import ImgTeamCarlos768 from "../assets/images/768px/768_carlos_silvani.png";
import ImgTeamRomina768 from "../assets/images/768px/768_romina_fiorenza.png";
import ImgTeamAlejandroC768 from "../assets/images/768px/768_alejandro_cabaccheff.png";
import ImgTeamLeonardo768 from "../assets/images/768px/768_leonardo_bonomo.png";
import ImgTeamMrSong768 from "../assets/images/768px/768_mr_song.png";
import ImgTeamMrWu768 from "../assets/images/768px/768_mr_wu_mr_wang.png";
/*  */
import ImgTeamDavid1440 from "../assets/images/1440px/1440_david_ding.png";
import ImgTeamUriel1440 from "../assets/images/1440px/1440_uriel_natero.png";
import ImgTeamHumberto1440 from "../assets/images/1440px/1440_humberto_bertazza.png";
import ImgTeamAlejandroO1440 from "../assets/images/1440px/1440_alejandro_ottero.png";
import ImgTeamMaria1440 from "../assets/images/1440px/1440_maria_mao.png";
import ImgTeamCarlos1440 from "../assets/images/1440px/1440_carlos_silvani.png";
import ImgTeamRomina1440 from "../assets/images/1440px/1440_romina_fiorenza.png";
import ImgTeamAlejandroC1440 from "../assets/images/1440px/1440_alejandro_cabaccheff.png";
import ImgTeamLeonardo1440 from "../assets/images/1440px/1440_leonardo_bonomo.png";
import ImgTeamMrSong1440 from "../assets/images/1440px/1440_mr_song.png";
import ImgTeamMrWu1440 from "../assets/images/1440px/1440_mr_wu_mr_wang.png";

import LogoFooterCh from "../assets/images/dings_logo_chino.svg";
import NavbarCh from "./navbar/navbarCh";
import AccordeonCh from "./accordeon/accordeonch";
import Carousel from "./carousel/carousel"

import Banner from "./bannerch/banner"
import "./ch.css";
import { Link } from "react-router-dom";

const Inicio = () => {
  const [width, setWidth] = useState(window.innerWidth);


  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    if (width < 1350){
      setIsOpen(!isOpen);
    }
  


  }
useEffect(()=>{ if (width > 768){
  setIsOpen(false);

}},[width])
   
  
  return (
    <>
      {/* Navbar */}
      <header>
      <nav>
          <div>
            <Link to="/ch" class="enlace">
            
              <img className="logonav"
              src={LogoFooterCh}
              />
            </Link>
          </div>
          <input checked  type="checkbox" id="check" style={{display
          :"none"}} />
        
          <ul  className={  isOpen ? 'ulnav' : 'hidden' }
 id="ulnav">
              <label onClick={toggleNavbar} class="checkbtn close" id="cerrar">
            <i  class="fa-solid fa-xmark"></i>
          </label>
            <li  onClick={toggleNavbar}><a  id="cerrarLink" for="check" href="#aboutus">About Us</a></li>

            <li onClick={toggleNavbar} ><a id="cerrarLink1" href="#services">Services</a></li>

            <li onClick={toggleNavbar} >
              <a id="cerrarLink2" href="#team">Team</a>
            </li>
            <li onClick={toggleNavbar} ><a id="cerrarLink3" href="#contact">Contact</a></li>
            <li className="listLenguage"><Link id="cerrarLink4" to="/en">EN</Link>|<Link to="/ch">中文</Link></li>
          </ul>
<button class="checkbtn" onClick={toggleNavbar}>
<i class="fas fa-bars"></i>
</button>
          
        </nav>
      </header>
      <Banner/>
      <div id="aboutus" className="banner">

        <div className="headerContainer">
          <div className="headerTextContainer">
            <Text value="促进您的业务" styleClass="textHeader" />
            <Title styleClass="titleHeader" value="丁老師阿根廷財稅諮詢公司" />
            <Text
              styleClass="textHeaderTwo"
              value="咨询结合本地经验和国际网络，确保专业"
            />
          </div>
          <div className="containerbuttonheader">
           <Link to="mailto:bocabeijing@qq.com"> <Button styleClass="btnPrimary buttonHeader" value="CONTACT US" /></Link>
          </div>
        </div>
      </div>
      <main>
        <Carousel/>
        {/*  <div className="contentContainer"> */}
        {/* aboutus */}
        <div className="aboutUsContainer">
          <div className="aboutUs">
            <Title styleClass="titleAboutUs" value="关于我们" />
            <Text
              styleClass="textAboutUs"
              value="是北京维亚海思商务咨询有限公司是阿根廷的分公司，概企业成立于1990年，主要为国内政府和企业进行境外的国际培训和国际咨询业务，我们是科技部国家外国专家局最早任命的境外培训渠道之一，多年来我们为科技部，国家税务总局，农业部，国家林业部，中国银行，工商银行，华为公司，航天工业集团等部委和企业进行了不同层面的海外业务培训和咨询工作，将本土经验和国际网络相结合，确保为企业提供专业、高效、品质的服务。"
            />
          </div>
          <div className="cards">
            <div className="cardOne">
              <img className="imgAboutUsOne" src={ImgAboutUsOne} />
              <div className="cardData">
                <Title styleClass="cardTitle" value="丁氏集团" />
                <Text
                  styleClass="cardText"
                  value="咨询结合本地经验和国际网络，确保为您的企业提供专业、高效、优质的服务。多年来，我们为科技部、国家税务总局、农业部、林业部、中国银行、中国工商银行、华为、航天工业集团"
                />
              </div>
            </div>
            <div className="divider"></div>
            <div className="cardOne">
              <img className="imgAboutUsOne" src={ImgAboutUsTwo} />
              <div  className="cardData">
                <Title
                  styleClass="cardTitle"
                  value="丰富的行业经验"
                />
                <Text
                  styleClass="cardText"
                  value="我们服务涉及的行业包括电子、机械设备、交 通、 电子商务、消费品、餐饮、金融业、服务业等。我们将不断总结经验，为您提供对行 业有深度理解的专业解决方案。"
                />
              </div>
            </div>
            <div className="divider"></div>
            <div className="cardOne">
              <img className="imgAboutUsOne" src={ImgAboutUsThree} />
              <div  className="cardData">
                <Title styleClass="cardTitle" value="专业的服务团队" />
                <Text
                  styleClass="cardText"
                  value="我们拥有一支优秀的专业团队，有多年的从业经验，其中包含注册会计师、注册税务 师、律师。
                  他们为客户提供专业的财税咨询、税收筹划、跨境税收咨询、转让定价、财税风险识 别及管控、企业管理咨询等服务。依托丰富的资源和广泛的实践，我们的专业人士将帮助您设计切实可行的解决方案。"
                />
              </div>
            </div>
          </div>
        </div>
        {/* OurServices */}
     <section id="services">
     <div  className="services">
          <Title styleClass="servicesTitle" value="我们的服务" />
          <Text
            styleClass="servicesText"
            value="我们为客户提供广泛的专业服务，如财税咨询、税务筹划、国际税务咨询、转让定价、财税相关风险控制、企业管理咨询等。凭借丰富的资源和广泛的实践，我们的专业人员将帮助您设计切实可行的解决方案。"
          />
          <AccordeonCh />

          <div className="servicesCards"></div>
        </div>
     </section>
        <div id="team" className="team">
          <div className="teamContentContainer">
            <Title styleClass="teamTitle" value="团队成员和合作伙伴" />
            <Text
              styleClass="teamText"
              value="在我们的核心，我们是问题解决者。我们经验丰富的专业团队提供多元化的专业服务，例如财务咨询、税务筹划和企业管理。我们相信实用的解决方案是关键，凭借我们广泛的资源和专业知识，我们有能力帮助您应对任何挑战。让我们共同努力，释放您企业的全部潜力。"
            />
          </div>
          <div className="cardsTeam">
            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
                {/*   <img className="imgTeam" src={ImgTeamDavid320} /> */}
                {/* 
              <img className="imgTeam" src={ImgTeamDavid768} />
              <img className="imgTeam" src={ImgTeamDavid1440} /> */}

                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamDavid320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamDavid768} />}
                {width > 1440 && <img src={ImgTeamDavid1440} />}

                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr.David Ding"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Professor of International Tax in Central University of Finance and Economics China (CUFE) and IEFPA Argentina"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
                {/*  <img className="imgTeam" src={ImgTeamUriel320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamUriel320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamUriel768} />}
                {width > 1440 && <img src={ImgTeamUriel1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamUriel768} />
              <img className="imgTeam" src={ImgTeamUriel1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Uriel Natero"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Argentina accountant"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
           {/*      <img className="imgTeam" src={ImgTeamHumberto320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamHumberto320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamHumberto768} />}
                {width > 1440 && <img src={ImgTeamHumberto1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamHumberto768} />
              <img className="imgTeam" src={ImgTeamHumberto1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Humberto Bertazza"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Argentina accountant"
                  />
                </div>
              </div>
            </div>

            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
          {/*       <img className="imgTeam" src={ImgTeamAlejandroO320} /> */}
          {width < 768 && (
                  <img className="imgTeam" src={ImgTeamAlejandroO320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamAlejandroO768} />}
                {width > 1440 && <img src={ImgTeamAlejandroO1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamAlejandroO768} />
              <img className="imgTeam" src={ImgTeamAlejandroO1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Alejandro Ottero"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Tax Officer
                Vicedecano de la Universidad Nacional de Moreno"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
               {/*  <img className="imgTeam" src={ImgTeamMaria320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamMaria320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamMaria768} />}
                {width > 1440 && <img src={ImgTeamMaria1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamMaria768} />
              <img className="imgTeam" src={ImgTeamMaria1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dra. Maria Mao"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Partner of PWC China"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
            {/*     <img className="imgTeam" src={ImgTeamCarlos320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamCarlos320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamCarlos768} />}
                {width > 1440 && <img src={ImgTeamCarlos1440} />}
                {/* 
              
              <img className="imgTeam" src={ImgTeamCarlos768} />
              <img className="imgTeam" src={ImgTeamCarlos1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Dr. Carlos Silvani"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Ex-Administrator of Taxation Authority"
                  />
                </div>
              </div>
            </div>
            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
     {/*            <img className="imgTeam" src={ImgTeamRomina320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamRomina320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamRomina768} />}
                {width > 1440 && <img src={ImgTeamRomina1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamRomina768} />
              <img className="imgTeam" src={ImgTeamRomina1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Lic. Romina Fiorenza"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="Public Administrator"
                  />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
                {/* <img className="imgTeam" src={ImgTeamAlejandroC320} /> */}
                {width < 768 && (
                  <img className="imgTeam" src={ImgTeamAlejandroC320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamAlejandroC768} />}
                {width > 1440 && <img src={ImgTeamAlejandroC1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamAlejandroC768} />
              <img className="imgTeam" src={ImgTeamAlejandroC1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Prof. Alejandro Cabaccheff"
                  />
                  <Text styleClass="cardsTeamText" value="Tax Officer" />
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
             {/*    <img className="imgTeam" src={ImgTeamLeonardo320} /> */}
             {width < 768 && (
                  <img className="imgTeam" src={ImgTeamLeonardo320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamLeonardo768} />}
                {width > 1440 && <img src={ImgTeamLeonardo1440} />}
                {/* 
              <img className="imgTeam" src={ImgTeamLeonardo768} />
              <img className="imgTeam" src={ImgTeamLeonardo1440} /> */}
                <div className="cardsTeamContent">
                  <TitleCard
                    styleClass="cardsTeamTitle"
                    value="Lic. Leonardo Bonomo"
                  />
                  <Text styleClass="cardsTeamText" value="Lawyer" />
                </div>
              </div>
            </div>
            <div className="cardsSubcontainer">
              <div className="cardsTeamOne">
               {/*  <img className="imgTeam" src={ImgTeamMrSong320} /> */}
               {width < 768 && (
                  <img className="imgTeam" src={ImgTeamMrSong320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamMrSong768} />}
                {width > 1440 && <img src={ImgTeamMrSong1440} />}
                {/*    <img className="imgTeam" src={ImgTeamMrSong768} />
              <img className="imgTeam" src={ImgTeamMrSong1440} /> */}
                <div className="cardsTeamContent">
                <div className="cardsTeamTitleContainer">
                  <TitleCard styleClass="cardsTeamTitle" value="宋宁" />
                  <Text
                    styleClass="cardsTeamText"
                    value="中税咨询集团董事长："
                  />
                  </div>
                </div>
              </div>
              <div className="teamDivider"></div>
              <div className="cardsTeamOne">
             {/*    <img className="imgTeam" src={ImgTeamMrWu320} /> */}
             {width < 768 && (
                  <img className="imgTeam" src={ImgTeamMrWu320} />
                )}
                {width >= 768 && width <= 1440 && <img src={ImgTeamMrWu768} />}
                {width > 1440 && <img src={ImgTeamMrWu1440} />}
                {/* <img className="imgTeam" src={ImgTeamMrWu768} />
              <img className="imgTeam" src={ImgTeamMrWu1440} /> */}

                <div className="cardsTeamContent">
                <div className="cardsTeamTitleContainer">
                <TitleCard styleClass="cardsTeamTitle" value="吴新联" />
                  <Text
                    styleClass="cardsTeamText"
                    value="原北京市国家税务局长："
                  />
                </div>
                <div className="cardsTeamTitleContainer">
                 <TitleCard
                    styleClass="cardsTeamTitle"
                    value="王裕康"
                  />
                  <Text
                    styleClass="cardsTeamText"
                    value="国家税务总局国际司副司长："
                  />
                 </div>
                </div>
              </div>
              <div className="teamDivider teamDividerEnd"></div>
            </div>
          </div>
        </div>
        {/*         </div> */}
        <div id="contact" className="contact">
          <h3 className="contactTitle">
          通过我们的顶级咨询服务释放您企业的潜力。我们的本地经验和全球网络确保提供高效、优质的服务。让我们凭借提供定制化海外业务培训和咨询的可靠记录助您一臂之力。联系我们开始吧！
          </h3>
    <Link to="mailto:bocabeijing@qq.com"> <Button styleClass="btnPrimary" value="CONTACT US"/></Link>
        </div>
        <footer>
          <div className="footerContainer">
            <img className="imgLogoFooter" src={LogoFooterCh} />
            <div className="footerContact">
              <div className="footerContent">
              <div className="footercolumn">
             <Text value="聯繫方式 (阿根廷)" styleClass="footerTitle" />
              <ul>
                <li>电话: (+54 11) 53560941  </li>
                <li>手机
: ( +54 9 11) 40566659</li>
                <ul className="emailList">
                  {" "}
                  电子邮件: bocabeijing@gmail.com |<li>bocabeijing@qq.com</li>
                </ul>
                <li>地址: Av. Alicia Moreau de Justo 1750, 1°Piso B</li>
              </ul>
             </div>
              </div>
              <div className="footerContent">
              <div className="footercolumn">
            <Text value="聯繫方式 (中國)" styleClass="footerTitle" />
              <ul>
                <li>电话 : ( +86) 010-63313490</li>
                <li>手机 : ( +86) 186-11536366</li>
              </ul>
            </div>
              </div>
            </div>
          </div>
          <div className="copy">
            <p>
              Powered by <Link to="https://flipa.ar/">Flipa©</Link>   - All rights reserved.
            </p>
          </div>
        </footer>
      </main>
    </>
  );
};

export default Inicio;
